import { Alert, Collapse, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";

import { LoginFormField } from "./LoginFormField";
import { RegisterForm } from "./RegisterForm";
import { ValidationForm } from "./ValidationForm";

import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import logoImage from "../../Assets/Images/Tolotech_logo_white_new.png";
import backgroundImage from "../../Assets/Images/background.jpg";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ForgotPassword } from "./ForgotPassword";

const styles = {
	paperContainer: {
		backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.5)), url(${backgroundImage})`,
		backgroundSize: "cover",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		minHeight: "100vh",
		width: "100vw",
		position: "fixed",
		top: 0,
		left: 0,
		zIndex: 1
	}
};

export const AdminLogin = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [showLogin, setShowLogin] = useState(true);
	const [showValidation, setShowValidation] = useState(false);
	const [showForgotPassword, setShowForgotPassword] = useState(false);
	const [showRegistration, setShowRegistration] = useState(false);
	const [showGDPR, setShowGDPR] = useState(true);
	const [userEmail, passUserEmail] = useState("");

	const switchComponent = (component) => {
		setShowRegistration(component === "registration");
		setShowLogin(component === "login");
		setShowValidation(component === "validation");
		setShowForgotPassword(component === "forgot");
	};

	useEffect(() => {
		console.log("AdminLogin useEffect");
		const token = document.cookie.split("webapp-token=")[1];
		if (token !== undefined) {
			navigate("/");
		}
	}, []);

	return (
		<>
			<div style={styles.paperContainer} />

			<Box
				sx={{
					height: "100%",
					width: isMobile ? undefined : "100%",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					overflow: "auto",
					position: "absolute"
				}}
			>
				<div style={{ flex: 1 }} />

				<Grid
					container
					spacing={2}
					direction="column"
					justifyContent="center"
					alignItems="center"
					sx={{
						position: "fixed",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)", // Center horizontally and vertically
						marginLeft: "0px", // style override
						width: isMobile ? "85%" : "450px",
						maxWidth: "450px",
						// height: "max-content",
						padding: isMobile ? "20px" : "40px",
						border: "1px solid " + ColorScheme.secondary + ColorScheme.opacity50,
						borderRadius: "14px",
						backgroundColor: ColorScheme.secondary + ColorScheme.opacity10,
						zIndex: 998
					}}
				>
					<Grid sx={{ padding: "25px" }}>
						<img
							src={logoImage}
							style={{
								display: "block",
								marginLeft: "auto",
								marginRight: "auto",
								height: "80px"
							}}
						/>
					</Grid>

					{showLogin && (
						<LoginFormField switchComponent={switchComponent} />
					)}
					{showValidation && (
						<ValidationForm
							switchComponent={switchComponent}
							userEmail={userEmail}
						/>
					)}
					{showRegistration && (
						<RegisterForm
							switchComponent={switchComponent}
							passUserEmail={passUserEmail}
						/>
					)}
					{showForgotPassword && (
						<ForgotPassword
							switchComponent={switchComponent}
							passUserEmail={passUserEmail}
						/>
					)}
				</Grid>

				<div style={{ flex: 1 }} />

				<Collapse
					in={showGDPR}
					sx={{
						display: "relative",
						zIndex: showGDPR ? 999 : 0,
						marginBottom: "50px",
						overflow: "none"
					}}
				>
					<Alert
						severity="info"
						variant="filled"
						onClose={() => setShowGDPR(!showGDPR)}
						closeText={t("gdpr.close")}
						sx={{
							position: "fixed",
							width: isMobile ? "80%" : "40%",
							left: "50%",
							bottom: "5%",
							transform: "translateX(-50%)"
						}}
					>
						<Typography>{t("gdpr.notice")}</Typography>
					</Alert>
				</Collapse>
			</Box>
		</>
	);
};
